/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Event_Trigger_No_SpacesInputs */



/**
* | output |
* | --- |
* | "You have no {connector} connection you can read. Connect one in Spaces first." |
*
* @param {Agent_Event_Trigger_No_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_no_spaces = /** @type {((inputs: Agent_Event_Trigger_No_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_No_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben keine lesbare ${i?.connector}-Verbindung. Verbinden Sie zuerst eine unter Spaces.`)
	return /** @type {LocalizedString} */ (`You have no ${i?.connector} connection you can read. Connect one in Spaces first.`)
});